/**
 * «Смотрю афишу музея…» — what the guide is doing, in words.
 *
 * Built from the tool names of the streaming message, translated by
 * `toolLabels`. A raw tool name never reaches the screen: that is a product
 * invariant, and the graph's own `scrub_tool_names` holds the same line on the
 * prose side.
 *
 * `neutral` is `peterhof_orch`'s line (`sessionStore.showsActivityFeed`): no
 * tool names at all, because the steps behind `delegate` are not the
 * conversation, and a step label there reads «Ищу…» over work the visitor
 * never asked to watch. The `delegate`'s own `say` line is already its bubble.
 */

import { useChat } from '../store/chatStore';
import { toolLabelsFor } from '../lib/toolLabels';

export default function ThinkingLine({ neutral = false }: { neutral?: boolean }) {
  const status = useChat((state) => state.status);
  const activity = useChat((state) => state.activity);

  if (status === 'idle') return null;

  const labels = neutral ? [] : toolLabelsFor(activity);
  const text =
    status === 'reconnecting'
      ? 'Связь прервалась, восстанавливаю…'
      : neutral
        ? 'Собираю ответ…'
        : labels.length > 0
          ? labels.join(' · ')
          : 'Думаю над ответом';

  return (
    <div className="thinking" role="status" aria-live="polite">
      {/* «Text-Thinking»'s own mark, as exported (36 × 36). */}
      <img className="thinking__dots" src="/figma/thinking-dots.svg" alt="" width="36" height="36" />
      <span className="thinking__text">{text}</span>
    </div>
  );
}
